import React, { Component } from 'react';
import configData from '../../temp/config';

class CommonImage extends Component {
    render() {
        return (
            <img src={`${configData.sitecoreApiHost}${this.props.imageIcon}`} alt="" />
        );
    }
}



export default CommonImage;